module.exports = __webpack_public_path__ + "img/toxic_positivity.8c1605c7.jpg";